import { TextfieldDefault } from "./TextfieldDefault"

export const TextInput = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldTouched }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <TextfieldDefault
    errors={touched[field.name] && errors[field.name]}
    onBlur={() => setFieldTouched(field.name)}
    {...field}
    {...props}
  />
)
